import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Student Info",
    href: (params) => `/map-fluency/${params.orderId}/1`,
  },
  {
    label: "Billing & Checkout",
    href: (params) => `/map-fluency/${params.orderId}/2`,
  },
]

export const FluencyStepper = () => {
  return <Stepper steps={steps} />
}
